define((require) => {
    "use strict";

    const _                             = require("underscore");
    const $                             = require("jquery");
    const AbstractWidgetView            = require("shared/ui/experience/widgets/AbstractWidgetView");
    const CompositeWidgetView           = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetView");
    const DynamicProductWidgetLayout    = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetLayout.js");
    const DynamicProductWidgetCollectionView = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetCollectionView");

    return CompositeWidgetView.extend("DynamicProductWidgetView", {

        tagName: "div",

        className: `${AbstractWidgetView.prototype.className} dynamic-product-widget`,

        hasTab: true,

        _$container: null,

        _$placeholderElement: null,

        _$label: null,

        _$icon: null,

        _tabProperties: {yOffset: 19, width: 54, height: 18},

        /**
         * Initialization
         */
        initialize() {
            this.__super();
            this.options.hasTab = this.hasTab;
            this.options.tabProperties = this._tabProperties;
        },

        showView() {
            if (this.groupCollection) {
                this._layout = new DynamicProductWidgetLayout({el: this.$el});
                this._layout.render();

                this._setGroupedWidgetCollectionView();

                if (!this.options.edited) {
                    _.defer(this._makeElementUnreachable.bind(this));
                }
            }

            this.__super();
        },

        updateRendering(element, bounds, active, edited) {
            if (edited) {
                if (this._$placeholderElement === null) {
                    this._$placeholderElement = $("<div class='placeholder'></div>")
                        .appendTo(element);
                }
            } else {
                element.css({
                    backgroundColor: "#fff"
                });
            }
        },

        _setGroupedWidgetCollectionView() {
            this.groupCollectionView = new DynamicProductWidgetCollectionView(_.extend(this.options, {
                collection: this.groupCollection,
                container: this._layout.group,
                compositeModel: this.model
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetView.js